import { AxiosResponse } from 'axios';
import api from '../../api';

class TeamService {
  getTeams() {
    return api.get('/team/');
  }
  getTeam(id: any) {
    return api.get(`/team/${id}`);
  }
  deleteTeam(id: any) {
    return api.delete(`/team/${id}`);
  }
  createTeam(payload: any): Promise<AxiosResponse<any | null>> {
    return api.post('/team/', payload);
  }
  editTeam(payload: any): Promise<AxiosResponse<any | null>> {
    return api.put('/team/', payload);
  }
  getUserTeam() {
    return api.get('/offline/team');
  }
}

export default new TeamService();
